
import SimpleEvent from './../../zviz2/zviz/event';
import {proxy} from './../../zviz2/zviz/functions';
import {scrollTo} from './../../tools';
import state from './../../zviz2/zviz/state';


class ThemeGraph{

    constructor(){

        this.events = [];

        this.themeIds = ['water', 'scc', 'aid', 'private', 'srhr', 'climate', 'srol', 'equality', 'food'];
        for(let id of this.themeIds){
            let elm = document.getElementById(id);
            this.events.push(new SimpleEvent(elm, 'mouseover', [this, this.onMouseOver]));
            this.events.push(new SimpleEvent(elm, 'mouseout', [this, this.onMouseOut]));
            this.events.push(new SimpleEvent(elm, 'click', [this, this.onClick]));
        }    
        
        this.setSize();
        this.events.push(new SimpleEvent(window, 'resize', [this, this.setSize]));

    }

    setSize(){
        var svg = document.getElementById('svgThemeExpenditures');
        if(svg){
            var w = svg.parentNode.clientWidth;
            svg.setAttribute('width', w + 'px');
            svg.setAttribute('height', Math.ceil(w*278/654) + 'px');
        }
    }

  

    onMouseOver(event){
        let id = event.currentTarget.id;
        state.set('tooltip', ['*'+window.themeTitles[id], window.themeClickMessage]);
        let elm = document.getElementById(id+'_circle');
        if(elm){
            elm.style.stroke = "white";
            elm.style.strokeWidth = '3px';
        }
    }

    onMouseOut(event){
        let id = event.currentTarget.id;
        state.set('tooltip', null);
        let elm = document.getElementById(id+'_circle');
        if(elm){
            elm.style.stroke = "none";
            elm.style.strokeWidth = '0px';
        }
    }

    onClick(event){
        let id = event.currentTarget.id;
        window.location.href = window.themeUrl + id;
    }


    remove(){
        for(let i = 0; i < this.events.length; i++){
            this.events[i].remove();
        }
        this.events = [];
    }

}

export default ThemeGraph;